import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Box } from '@mui/material'
import { BarChart } from '@mui/x-charts'
import styles from '../SuperAdminDashboard.module.scss'

export function AdminProposalValueChartCard() {
	const proposalValueByMonthSeries = useSelector(
		(s) => s.admin.proposalValueByMonthSeries
	)
	const proposalValueByMonthChartLoading = useSelector(
		(s) => s.admin.proposalValueByMonthChartLoading
	)
	const proposalValueByMonthChartError = useSelector(
		(s) => s.admin.proposalValueByMonthChartError
	)

	const proposalDataset = useMemo(() => {
		if (!Array.isArray(proposalValueByMonthSeries)) return []
		return proposalValueByMonthSeries.map((r) => ({
			month: r.month,
			totalValue: r.totalValue,
		}))
	}, [proposalValueByMonthSeries])

	return (
		<div className={styles.chartCard}>
			<h2 className={styles.chartCardTitle}>
				Accepted proposal value by month
			</h2>
			<p className={styles.chartCaption}>
				Sum of bid amounts for approved proposals. Month is from proposal
				updatedAt (acceptance proxy).
			</p>
			{proposalValueByMonthChartLoading ? (
				<p className={styles.chartPlaceholder}>Loading…</p>
			) : proposalValueByMonthChartError ? (
				<p className={styles.statsErrorInline}>
					{proposalValueByMonthChartError}
				</p>
			) : proposalDataset.length === 0 ? (
				<p className={styles.chartPlaceholder}>No data</p>
			) : (
				<Box className={styles.chartInner}>
					<BarChart
						dataset={proposalDataset}
						xAxis={[
							{
								dataKey: 'month',
								scaleType: 'band',
								label: 'Month (UTC)',
							},
						]}
						series={[
							{
								dataKey: 'totalValue',
								label: 'Total value',
								color: '#7ca6bd',
							},
						]}
						grid={{ horizontal: true, vertical: false }}
						margin={{
							top: 48,
							right: 12,
							bottom: 48,
							left: 56,
						}}
						height={320}
						hideLegend
					/>
				</Box>
			)}
		</div>
	)
}
